/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Type } from "@adapptio/lib-blueprint";
import { IActionContext, INodeContext, INodeResult } from "../ActionManager";
import { TAllNodesSpec, TBlueprintRedirectNodeOptsSchemaSpec } from "../../blueprints";
import { createSuccessNodeResult } from "../helpers";

export async function redirectNodeHandler<TSpec extends Partial<TAllNodesSpec>>(
	opts: TBlueprintRedirectNodeOptsSchemaSpec,
	aCtx: IActionContext<TSpec>,
	nCtx: INodeContext
): Promise<INodeResult> {
	return createSuccessNodeResult(
		{
			opts,
			outputName: null,
			data: opts,
			typeDescriptor: Type.Object({
				props: {
					url: Type.String({}),
					status: Type.Integer({}),
					headers: Type.Map({
						items: { "[K: string]": Type.String({}) }
					}),
					body: Type.Any({})
				}
			})
		},
		aCtx,
		nCtx
	);
}
